interface AuthConfig {
  url?: string
  realm?: string
  clientId?: string
}

export const getAuthConfig = (): AuthConfig | undefined | null => {
  return window['__AUTH__']
}
